module.exports = __webpack_public_path__ + "close.svg?5d35edb1630fbb8e3098a29cc29a4e4c";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/close.svg
// module id = 104
// module chunks = 0